<template>
  <div class="lesson-wrapper">
    <div class="column-left">
      <p class="typed code" ref="typed"></p>
    </div>
    <div class="column-right">
      <h3>{{slide.title}}</h3>
      <video ref="video" :id="index" :poster="slide.posterImageUrl" webkit-playsinline playsinline :src="videosource" />
      <button class="button previous-button bottom left" @click="goToPreviousSlide">←</button>
      <button class="button next-button bottom right" v-if="this.$store.state.slidesComplete >= index" @click="goToNextSlide">→</button>
      <button class="button run-button bottom center border" v-if="this.$store.state.slidesComplete < index && !isVideoIsPlaying && isTextTyped" @click="runVideo">Run the Code</button>
      <button class="button restart-button bottom center border" v-if="this.$store.state.slidesComplete >= index && !isVideoIsPlaying" @click="runVideo">Restart</button>
    </div>
  </div>
</template>

<script>
import Typed from 'typed.js'

export default {
  name: 'Lesson',
  props: [
    'slide',
    'slider',
    'index',
    'isShowInfo',
  ],

  data() {
    return {
      typed: '',
      isTextTyped: false,
      isVideoIsPlaying: false,
      isVideoStarted: false,
      isVideoPlayedThrough: false,
      videosource: '',
    }
  },

  created() {
    // NEW
    this.$eventHub.$on('slideSettled', this.slideSettled)
    this.$eventHub.$on('slideSelected', this.slideSelected)
  },

  beforeDestroy() {
    // new
    this.$eventHub.$off('slideSettled')
    this.$eventHub.$off('slideSelected')
  },

  mounted() {
    this.$refs.video.addEventListener('pause', () => {
      // console.log('video is paused')
      this.isVideoIsPlaying = false
    })
    this.$refs.video.addEventListener('playing', () => {
      // console.log('video is playing')
      this.isVideoStarted = true
      this.isVideoIsPlaying = true
    })
    this.$refs.video.addEventListener('ended', () => {
      // console.log('video ended')
      this.isVideoIsPlaying = false
      this.isVideoPlayedThrough = true
      this.VideoPlayedThrough()
    })

    if (this.$store.state.slidesComplete >= this.index) {
      this.runText(0)
      this.isVideoPlayedThrough = true
    }
  },

  methods: {

    // NEW
    slideSettled() {
      if (this.slider.selectedIndex() === this.index && !this.typed) {
        this.runText(30)
      }
    },

    slideSelected() {
      if (this.slider.selectedIndex() === this.index || this.slider.selectedIndex() === this.index - 1 || this.slider.selectedIndex() === this.index + 1) {
        this.videosource = this.slide.videoUrls[this.$store.state.VideoSize]
      }
      if (this.isVideoIsPlaying) {
        this.$refs.video.pause()
        this.$refs.video.currentTime = 0
      }
    },

    completeSlide(typespeed) {
      this.runText(typespeed)
    },

    initSlide() {

    },

    runText(typeSpeed) {
      const options = {
        strings: [this.slide.assignment],
        typeSpeed,
        showCursor: false,
        onComplete: this.showRunButton,
      }
      setTimeout(() => {
        this.typed = new Typed(this.$refs.typed, options)
      }, 400)
    },

    showRunButton() {
      this.isTextTyped = true
    },

    runVideo() {
      // console.log(this.$refs.video)
      // console.log('video should play')
      this.$refs.video.play()
    },

    VideoPlayedThrough() {
      this.$store.dispatch('setSlidesComplete', this.index)
    },

    goToNextSlide() {
      this.slider.next()
    },

    goToPreviousSlide() {
      this.slider.previous()
    },

  },

}

</script>


<style lang="scss" scoped>

@mixin small {
  @media (max-width: 320px) {
    @content;
  }
}

@mixin tablet {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 1300px) {
    @content;
  }
}

.lesson-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;

  .column-left {
    width: 38%;
    height: 100%;
    top: 0;
    left: 0;
    background: black;
    position: relative;
    height: 100%;

      .typed {
        padding: 16px 20px;
        height: 100%;
        pointer-events: all;


        @include tablet {
          padding: 20px 24px;
        }

        @include desktop {
          padding: 33px 33px;
        }




    }

  }

  .column-right {
    width: 62%;
    height: 100%;
    top: 0;
    left: 38%;
    background: black;
    overflow: hidden;
    position: absolute;
    z-index: -2;

    h3 {
      position: absolute;
      top: 15px;
      display: inline;
      text-align: center;
      max-width: 70%;
      left: 50%;
      transform: translateX(-50%);

      @include tablet {
        top: 24px;
      }

      @include desktop {
        top: 31px;
      }

    }

    video {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
      z-index: -1;
    }

  }

}

</style>



// WEBPACK FOOTER //
// src/components/Lesson.vue